namespace RioERP.Common {
    export enum SMSStatus {
        Failed = -1,
        InQueue = 0,
        Sent = 1
    }
    Serenity.Decorators.registerEnumType(SMSStatus, 'RioERP.Common.SMSStatus');
}
